import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../tpsSideBar.css';

const SideNav = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 990);
  const [mastersOpen, setMastersOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);

  const userName = localStorage.getItem('ReviewerName') || 'Guest';

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 990);
      // Close submenus on resize to avoid weird UI
      setMastersOpen(false);
      setReportsOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('ReviewerName');
    localStorage.removeItem('reviewerID');
    window.location.href = '/cl';
  };

  return (
    <>
      {/* Toggle button for mobile */}
      {!isSidebarOpen && (
        <button
          className="toggle-btn rounded"
          onClick={() => setIsSidebarOpen(true)}
          aria-label="Open sidebar"
        >
          ≡
        </button>
      )}

      {/* Sidebar */}
      <aside className={`off-canvas-menu ${isSidebarOpen ? 'open' : ''}`}>
        <div className="brand">TPS Reviewer</div>
        <div className="user-panel border border-white p-2 rounded">Welcome: {userName}</div>

        <nav>
          <ul>
            <li>
              <Link to="/reviewer/dashboard" onClick={() => setIsSidebarOpen(window.innerWidth >= 990)}>
                Dashboard
              </Link>
            </li>

            <li>
              <button
                onClick={() => setMastersOpen(!mastersOpen)}
                aria-expanded={mastersOpen}
                aria-controls="masters-submenu"
              >
                Masters {mastersOpen ? '▲' : '▼'}
              </button>
              {mastersOpen && (
                <ul id="masters-submenu">
                  <li>
                    <Link
                      to="/reviewer/review-submissions"
                      onClick={() => setIsSidebarOpen(window.innerWidth >= 990)}
                    >
                      Submission Review
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <button
                onClick={() => setReportsOpen(!reportsOpen)}
                aria-expanded={reportsOpen}
                aria-controls="reports-submenu"
              >
                Reports {reportsOpen ? '▲' : '▼'}
              </button>
              {reportsOpen && (
                <ul id="reports-submenu">
                  <li>
                    <Link
                      to="/reviewer/review-all-papers"
                      onClick={() => setIsSidebarOpen(window.innerWidth >= 990)}
                    >
                      Your Assigned papers
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/reviewer/review-comments"
                      onClick={() => setIsSidebarOpen(window.innerWidth >= 990)}
                    >
                      All Papers
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <button className="logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && window.innerWidth < 990 && (
        <div className="overlay" onClick={() => setIsSidebarOpen(false)} />
      )}
    </>
  );
};

export default SideNav;
